import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { AppSettings } from '../../../../../app.settings';
import { Settings } from '../../../../../app.settings.model';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeleteComponent implements OnInit {
  settings: Settings;
  @Input('title1') title1: string;
  @Input('title2') title2: string;
  @Input('statment1') statment1: string;
  @Input('statment2') statment2: string;
  @Input('statment3') statment3: string;
  @Output('deleteAction') deleteAction = new EventEmitter();
  @Output('closeAction') closeAction = new EventEmitter();
  activePage = 1;
  password: string;
  deletekey: string;

  constructor(private appSetting: AppSettings, public modalservice: BsModalService, public modalRef: BsModalRef) {
    this.settings = this.appSetting.settings;
  }

  ngOnInit() {
    this.password = '';
    this.deletekey = '';
  }
  ChangePage() {
    this.activePage = 2;
  }
  delete() {
    this.deleteAction.emit(true);
    this.modalRef.hide();
  }

  validate() {
    return this.deletekey.toLocaleLowerCase() === 'delete' && this.password !== '';
  }
}
